import { connect } from 'react-redux';
import LoadingScreen from  './LoadingScreen';

//Binding the data
const mapStateToProps = (state) => {
    return {
        loading: state.isLoading
    }
}


export default connect(mapStateToProps, null)(LoadingScreen);


// WEBPACK FOOTER //
// ./src/redux/components/organisms/LoadingScreen/LoadingScreenContainer.js